import { defineMessages } from 'react-intl';

export default defineMessages({
	label: {
		defaultMessage: 'Password',
		description: 'Label for the password input field in the login form.',
		id: 'password.field.label',
	},
	showPassword: {
		defaultMessage: 'Show',
		description: 'Label for the button to show the password in the password field.',
		id: 'password.show.button.label',
	},
	hidePassword: {
		defaultMessage: 'Hide',
		description: 'Label for the button to hide the password in the password field.',
		id: 'password.hide.button.label',
	},
});
